export default __webpack_public_path__ + "img/39b90a368fe5bf0d91d3af92d130dbc3.png";